import * as Sentry from '@sentry/react';

export function initializeSentry() {
  if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
      environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
      integrations: [Sentry.browserTracingIntegration()],
      sendDefaultPii: false,
      // Performance Monitoring
      tracesSampleRate: 0.0,
      // Session Replay
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 0.0,
      // Filtering
      allowUrls: [/https?:\/\/www\.trovanorma\.it/],
      beforeSend(event, hint) {
        // Filter out AbortError related to video play/pause interruptions
        const error = hint.originalException;
        if (error && typeof error === 'object') {
          const message = 'message' in error ? String(error.message) : '';
          if (message.includes('AbortError') && message.includes('play() request was interrupted')) {
            return null;
          }
        }
        return event;
      },
    });
  }
}
